var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "email-card" },
    [
      _c("template-card-v2", {
        attrs: {
          oneLog: _vm.oneLog,
          linkedtype: _vm.linkedtype,
          linkedid: _vm.linkedid
        },
        scopedSlots: _vm._u(
          [
            {
              key: "icon",
              fn: function() {
                return [
                  _vm.emailStatus.includes(_vm.oneLog.email.status)
                    ? _c("CompassObject", {
                        attrs: { object: "sent-email", size: "small" }
                      })
                    : ["replied", "received"].includes(_vm.oneLog.email.status)
                    ? _c("CompassObject", {
                        attrs: { object: "inbox-email", size: "small" }
                      })
                    : _vm._e()
                ]
              },
              proxy: true
            },
            ["replied", "received"].includes(_vm.oneLog.email.status)
              ? {
                  key: "label",
                  fn: function() {
                    return [
                      _vm.oneLog.email.from
                        ? _c(
                            "span",
                            {
                              staticClass:
                                "semibold gray-80 fs-2 email-card-status-sender__label"
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$l10n.__("De : %(emailSender)s", {
                                      emailSender: _vm.oneLog.email.from.email
                                    })
                                  ) +
                                  "\n            "
                              )
                            ]
                          )
                        : _vm._e()
                    ]
                  },
                  proxy: true
                }
              : _vm.oneLog.owner
              ? {
                  key: "label",
                  fn: function() {
                    return [
                      _c(
                        "div",
                        { staticClass: "flex-row" },
                        [
                          _c("person-list-light", {
                            attrs: { list: [_vm.oneLog.owner] }
                          }),
                          _vm._v(" "),
                          _vm.hasStatusConfig
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "flex-level wp-10 ml-2 email-card-status__container"
                                },
                                [
                                  _c("CompassIcon", {
                                    attrs: {
                                      type: _vm.getStatusConfig.iconColor,
                                      size: "extra-small",
                                      icon: _vm.getStatusConfig.icon
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      class:
                                        "ml-1 fs-2 " + _vm.getStatusConfig.color
                                    },
                                    [
                                      _vm._v(
                                        "\n                        " +
                                          _vm._s(_vm.getStatusConfig.label) +
                                          "\n                    "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  },
                  proxy: true
                }
              : null,
            {
              key: "content",
              fn: function() {
                return [
                  _c("div", [
                    _vm.oneLog.email.subject
                      ? _c(
                          "span",
                          {
                            staticClass:
                              "typographies-paragraph-medium-semibold email-card-title",
                            on: {
                              click: function($event) {
                                return _vm.mailPreview(_vm.oneLog)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.sanitizeQuotes(_vm.oneLog.email.subject)
                                ) +
                                "\n                "
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("p", {
                      staticClass:
                        "typographies-paragraph-medium-regular email-card__content",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.sanitizeQuotes(_vm.oneLog.email.description)
                        )
                      }
                    })
                  ])
                ]
              },
              proxy: true
            }
          ],
          null,
          true
        )
      }),
      _vm._v(" "),
      _c("CompassDialog", {
        attrs: {
          visible: _vm.cancelModal,
          size: "small",
          title: _vm.$t.__("common.actions.cancel_sending_email")
        },
        on: {
          "update:visible": function($event) {
            _vm.cancelModal = $event
          }
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function() {
              return [
                _c("div", { staticClass: "dialog__default" }, [
                  _c(
                    "p",
                    { staticClass: "typographies-paragraph-medium-regular" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$l10n.__(
                              "Confirmez-vous vouloir annuler l'envoi de cet email programmé ?"
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "ul",
                    { staticClass: "typographies-paragraph-medium-regular" },
                    [
                      _c("li", [
                        _vm._v(
                          "- " +
                            _vm._s(
                              _vm.$l10n.__(
                                "Le destinataire ne recevra jamais cet email."
                              )
                            )
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _vm._v(
                          "- " +
                            _vm._s(
                              _vm.$l10n.__(
                                "Il n’apparaitra plus dans l’activité"
                              )
                            )
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _vm._v(
                          "- " +
                            _vm._s(
                              _vm.$l10n.__("Ceci est une action définitive.")
                            )
                        )
                      ])
                    ]
                  )
                ])
              ]
            },
            proxy: true
          },
          {
            key: "footer",
            fn: function() {
              return [
                _c(
                  "div",
                  { staticClass: "dialog__footer" },
                  [
                    _c("CompassButton", {
                      attrs: {
                        label: _vm.$t.__("common.actions.cancel"),
                        type: "secondary"
                      },
                      on: {
                        click: function($event) {
                          _vm.cancelModal = false
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("CompassButton", {
                      staticClass: "ml-3",
                      attrs: {
                        label: _vm.$t.__(
                          "common.actions.confirm_cancel_sending"
                        ),
                        type: "primary"
                      },
                      on: {
                        click: function($event) {
                          return _vm.cancelMail(_vm.oneLog)
                        }
                      }
                    })
                  ],
                  1
                )
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }